import { render, staticRenderFns } from "./delete.vue?vue&type=template&id=c454d20a&scoped=true&"
import script from "./delete.vue?vue&type=script&lang=js&"
export * from "./delete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c454d20a",
  null
  
)

export default component.exports